import { createSlice } from "@reduxjs/toolkit";
import { GetStrategyVariance, postRebalance, getRebalance, Taxlots, postOrder, getOnboardedInvestors, getInvestorsByEmail } from "../Actions/transactionService";
// import customSuccessAlert from "../../Alerts/customSuccessAlert";
import customSuccessAlert from './../../Alerts/customSuccessAlert';
const initialState = {
  error: "",
  code: "",
  status: "",
  loading: false,
  transData: [],
  strategyData: [],
  orders: [],
  lots: [],
  onboardedInvestors: [],
  onboardedInvestorsLoading: false,
  investorsByEmail: [],
  investorsByEmailLoading: false,
  showSuccessAlert: false,
};
const transactionReducer = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    closeSuccessAlert: (state) => {
      state.showSuccessAlert = false;
    }
  },
  extraReducers: {
    [GetStrategyVariance.pending]: (state, action) => {
      state.loading = true;
    },
    [GetStrategyVariance.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;
      if ((statusCode === 200 ) && data) {
        state.message = message;
        state.status = status;
        state.code = statusCode;
        state.strategyData = data;
      } else {
        state.strategyData = [];
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [GetStrategyVariance.rejected]: (state) => {
      state.loading = false;
    },
    [postRebalance.pending]: (state, action) => {
      state.loading = true;
    },
    [postRebalance.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;

      if ((statusCode === 201 ) && data) {
        customSuccessAlert("Rebalanceed Successfully")
        state.message = message;
        state.status = status;
        state.code = statusCode;
        state.rebalance=data
        state.showSuccessAlert = true;
      } else {
       
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [postRebalance.rejected]: (state) => {
      state.loading = false;
    },

    [getRebalance.pending]: (state, action) => {
      state.loading = true;
    },
    [getRebalance.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;

      if ((statusCode === 200 ) && data) {
        state.message = message;
        state.status = status;
        state.code = statusCode;
        state.orders=data?.orders
      } else {  
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [getRebalance.rejected]: (state) => {
      state.loading = false;
    },


    [Taxlots.pending]: (state, action) => {
      state.loading = true;
    },
    [Taxlots.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;

      if ((statusCode === 200 ) && data) {
        state.message = message;
        state.status = status;
        state.code = statusCode;
        state.lots=data?.unrealizedSecurityLots
      } else {  
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [Taxlots.rejected]: (state) => {
      state.loading = false;
    },


    [postOrder.pending]: (state, action) => {
      state.loading = true;
    },
    [postOrder.fulfilled]: (
      state,
      { payload: {  message, statusCode } }
    ) => {
      state.loading = false;
      if (statusCode === 201 ) {
        state.message = message;
        state.code = statusCode;
      } else {  
        state.error = message;
        state.code = statusCode;
      }
    },
    [postOrder.rejected]: (state) => {
      state.loading = false;
    },

    [getOnboardedInvestors.pending]: (state, action) => {
      state.onboardedInvestorsLoading = true;
    },
    [getOnboardedInvestors.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.onboardedInvestorsLoading = false;
      if (statusCode === 200 && data) {
        state.message = message;
        state.status = status;
        state.code = statusCode;
        state.onboardedInvestors = data;
      } else {
        state.onboardedInvestors = [];
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [getOnboardedInvestors.rejected]: (state) => {
      state.onboardedInvestorsLoading = false;
    },

    [getInvestorsByEmail.pending]: (state, action) => {
      state.investorsByEmailLoading = true;
    },
    [getInvestorsByEmail.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.investorsByEmailLoading = false;
      if (statusCode === 200 && data) {
        state.message = message;
        state.status = status;
        state.code = statusCode;
        state.investorsByEmail = data;
      } else {
        state.investorsByEmail = [];
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [getInvestorsByEmail.rejected]: (state) => {
      state.investorsByEmailLoading = false;
    },
  },
});

export const { closeSuccessAlert } = transactionReducer.actions;
export default transactionReducer.reducer;
